import createSvgIcon from './utils/createSvgIcon';
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("circle", {
  cx: "12",
  cy: "10",
  r: "1"
}, "0"), /*#__PURE__*/_jsx("circle", {
  cx: "16",
  cy: "10",
  r: "1"
}, "1"), /*#__PURE__*/_jsx("circle", {
  cx: "20",
  cy: "10",
  r: "1"
}, "2"), /*#__PURE__*/_jsx("path", {
  d: "m15.63 14.4-2.52 2.5c-2.5-1.43-4.57-3.5-6-6l2.5-2.52c.23-.24.33-.57.27-.9L9.13 3.8c-.09-.46-.5-.8-.98-.8H4c-.56 0-1.03.47-1 1.03.17 2.89 1.05 5.6 2.43 7.97 1.58 2.73 3.85 4.99 6.57 6.57 2.37 1.37 5.08 2.26 7.97 2.43.56.03 1.03-.44 1.03-1v-4.15c0-.48-.34-.89-.8-.98l-3.67-.73c-.33-.07-.67.03-.9.26z"
}, "3")], 'SettingsPhoneRounded');